import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import StandardTextField from 'Utils/redux_form_inputs/StandardTextField';
import StandardSelectField from 'Utils/redux_form_inputs/StandardSelectField';
import StandardRegionDropdown from 'Utils/redux_form_inputs/StandardRegionDropdown';
import Validator from 'HelperFunctions/validator';
import { Link } from 'react-router-dom';
import { setErrors } from 'Actions';

// Validation rules
const validations = {
  country: { required: { value: true, message: 'Country is required' } },
  street_address1: {
    required: { value: true, message: 'Address is required' },
  },
  city: { required: { value: true, message: 'City is required' } },
  locale: { required: { value: true, message: 'State is required' } },
  postal_code: { required: { value: true, message: 'Zip code is required' } },
  payment_method_type: {
    required: { value: true, message: 'Bank Type is required' },
  },
  check_type: { required: { value: true, message: 'Check Type is required' } },
  bank_number: {
    required: { value: true, message: 'Routing Number is invalid' },
  },
  account_number: {
    required: { value: true, message: 'Account Number is required' },
  },
  first_name: { required: { value: true, message: 'First Name is required' } },
  last_name: { required: { value: true, message: 'Last Name is required' } },
  ach_authorization: {
    required: { value: true, message: 'You must authorize ACH debits' },
  },
};

class WorldpayBankForm extends React.Component {
  render() {
    const { handleSubmit, type, country, check_type, ach_authorization } =
      this.props;

    return (
      <form id='payment-form' onSubmit={handleSubmit} className='form'>
        <div className='fields'>
          <Field name='country' component={StandardSelectField}>
            <option value=''>Select country</option>
            <option value='USA'>United States</option>
            <option value='CAN'>Canada</option>
          </Field>
          <Field
            name='street_address1'
            placeholder='Street Address'
            component={StandardTextField}
            className='lg'
            type='text'
          />
          <Field
            name='street_address2'
            placeholder='Suite #'
            component={StandardTextField}
            className='sm'
            type='text'
          />
          <Field
            name='city'
            placeholder='City'
            component={StandardTextField}
            className='med'
            type='text'
          />
          <Field
            name='locale'
            component={StandardRegionDropdown}
            defaultOptionLabel={country === 'USA' ? 'State' : 'Province'}
            className='sm'
            disableWhenEmpty={true}
            countryValueType='short'
            labelType='short'
            valueType='short'
            country={country || 'USA'}
          />
          <Field
            name='postal_code'
            placeholder='Postal Code'
            component={StandardTextField}
            className='sm'
            type='text'
          />
          <Field name='payment_method_type' component={StandardSelectField}>
            <option>Select Payment Method Type</option>
            <option value='Checking'>Checking</option>
            <option value='Savings'>Savings</option>
          </Field>
          <Field name='check_type' component={StandardSelectField}>
            <option>Check Type</option>
            <option value='Personal'>Personal</option>
            <option value='Business'>Business</option>
          </Field>
          {check_type === 'Business' && (
            <Field
              name='company_name'
              placeholder='Company Name'
              component={StandardTextField}
              type='text'
            />
          )}
          <Field
            name='bank_number'
            placeholder='Routing Number'
            component={StandardTextField}
            type='text'
          />
          <Field
            name='account_number'
            placeholder='Account Number'
            component={StandardTextField}
            type='text'
          />
          <Field
            name='first_name'
            placeholder='First name of the bank account'
            component={StandardTextField}
            type='text'
          />
          <Field
            name='last_name'
            placeholder='Last name of the bank account'
            component={StandardTextField}
            type='text'
          />
        </div>

        {type === 'checkout' && (
          <div className='actions' style={{ gridTemplateColumns: '1fr' }}>
            <div
              className='authorization'
              style={{
                marginBottom: '1em',
                fontSize: '0.875em',
                lineHeight: 1.4,
                textAlign: 'justify',
              }}
            >
              <label style={{ display: 'flex', alignItems: 'flex-start' }}>
                <Field
                  name='ach_authorization'
                  id='ach_authorization'
                  component='input'
                  type='checkbox'
                  style={{ margin: '0.2em 0.5em 0 0' }}
                />
                <p
                  style={{
                    overflowY: 'scroll',
                    paddingRight: '1rem',
                    height: '5rem',
                  }}
                >
                  By clicking “Submit Payment”, I authorize the merchant named
                  above to initiate ACH debits from the bank account I have
                  provided. This includes an initial payment, any recurring
                  payments, and, if applicable, a final payment scheduled closer
                  to the time of delivery or service. I understand that I may
                  not receive advance notice of each debit, but will be notified
                  once a payment has been processed. I confirm I am authorized
                  to use this bank account and that this transaction complies
                  with all applicable laws. This authorization remains in effect
                  until all payments are completed or I cancel it by contacting
                  the merchant, allowing reasonable time for action.
                </p>
              </label>
            </div>
            <button type='submit' className='btnIcon full'>
              Submit Payment
            </button>
          </div>
        )}

        {type === 'add-bank-acount' && (
          <div className='actions'>
            <button type='submit' className='btn'>
              Add Bank Account
            </button>
            <Link to='/profile/paymentMethods' className='btn cancel'>
              Cancel
            </Link>
          </div>
        )}
      </form>
    );
  }
}

WorldpayBankForm = reduxForm({
  form: 'NewBankForm',
  validate: Validator(validations),
  onSubmitFail: (errors, dispatch) => {
    if (errors) dispatch(setErrors(errors));
  },
})(WorldpayBankForm);

const selector = formValueSelector('NewBankForm');
WorldpayBankForm = connect((state) => {
  const country = selector(state, 'country');
  const check_type = selector(state, 'check_type');
  const ach_authorization = selector(state, 'ach_authorization');
  return { country, check_type, ach_authorization };
})(WorldpayBankForm);

export default WorldpayBankForm;
